"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyle = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
exports.GlobalStyle = (0, styled_components_1.createGlobalStyle) `
  * {
    box-sizing: border-box;
    flex-shrink: 1;
  }
  :focus-visible {
    outline-style: solid;
    outline-width: 0.5px;
    outline-color: #fffa;
    outline-offset: -1px;
  }
  ::-moz-focus-inner {
    border: 0;
  }
  html,
  body,
  #app {
    min-height: 100%;
    height: 100%;
    overflow: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: "Segoe UI", "Segoe Symbol", system-ui, sans-serif;
    margin: 0;
    padding: 0;
    font-size: 13px;
    min-height: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: ${(props) => props.theme.bg};
    color: ${(props) => props.theme.fg};
    display: flex;
    flex-direction: column;
    /* W3C working draft standard - supported in Firefox since 2018, Chrome/Edge since 2024, Safari not yet */
    scrollbar-color: #555 #333;
    scrollbar-width: thin;
  }
  html {
    // This fixes occasional problems where a popup that overflows the screen causes the whole app to shift out of the viewport
    position: fixed;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: lighter;
  }
  h1 {
    font-size: 1.5em;
  }
  h2 {
    font-size: 1.3em;
  }
  h3 {
    font-size: 1.1em;
    font-weight: normal;
  }

  a {
    text-decoration: none;
    color: white;
  }

  a.router-link-exact-active {
    color: ${(props) => props.theme.highlight};
  }

  input, button, select {
    font-family: inherit;
  }

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    padding: 5px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4.5px;
    background: #555;
    box-shadow: 1px 0px #000, inset 1px 0px rgba(255, 255, 255, 0.2);
  }

  // contain and content-visibility can help with rendering performance; add to self-contained units of content
  svg, canvas {
    contain: content;
    content-visibility: auto;
  }

  .hover-highlight {
    cursor: pointer;
    &:hover {
      background-color: #ffffff26;
    }
    &:active {
      background-color: #0003;
    }
  }

  .backdrop {
    div, button {
      pointer-events: none;
    }
    filter: blur(2px) contrast(.5) brightness(.5);
  }
`;
//# sourceMappingURL=GlobalStyle.js.map